export default "__VITE_ASSET__DdZs6Ihj__"